import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Aircraftwatch } from 'src/app/models/flight-watch';

export interface AicraftPopUpDialogData {
    fboId: number;
    flightData: Aircraftwatch;
    groupId: number | null;
    showFavoriteButton: boolean;
}

@Component({
    selector: 'app-aircraft-data-dialog',
    templateUrl: './aircraft-data-dialog.component.html',
    styleUrls: ['./aircraft-data-dialog.component.scss'],
})
export class AircraftDataDialogComponent {
    @Output() dialogClosed = new EventEmitter<Aircraftwatch>();
    @Output() cancelDialog = new EventEmitter<void>();

    private _data: AicraftPopUpDialogData;
    get data(): AicraftPopUpDialogData {
        return this._data;
    }
    set data(value: AicraftPopUpDialogData) {
        this._data = value;
    }

    constructor() {
        this._data = { fboId: null, flightData: null, groupId: null, showFavoriteButton: true };
    }

    onNoClick(): void {
        this.cancelDialog.emit();
    }

    // Method to handle when flightData is updated (can be called from child component)
    onFlightDataUpdated(flightData: Aircraftwatch): void {
        this.dialogClosed.emit(flightData);
    }
}
